export var MessagePropStage = /*#__PURE__*/function (MessagePropStage) {
  MessagePropStage["PENDING"] = "pending";
  MessagePropStage["SUBMITED"] = "submited";
  MessagePropStage["READED"] = "readed";
  MessagePropStage["UNKNOWN"] = "unknown";
  MessagePropStage["REJECTED"] = "rejected";
  return MessagePropStage;
}({});